import ActiveController from "./controller";
import ActiveService from "./service.active";

export const $controller = ActiveController;
export const $service = ActiveService;
export const bindings = {
	resolve : "<",
	close   : "&",
	dismiss : "&"
};


// WEBPACK FOOTER //
// ./rapid/index.js